import { delegateEvent } from 'src/utils/dom.js';

export function initLandingLinksTracking() {
  delegateEvent(document, 'click', '.js-vacancy-landing-link', (event, target) => {
    const { href } = target;

    if (!href) return;

    const linkSections = href.split('/')
    const landingSlug = linkSections[linkSections.length - 1]

    window.helpers.trackEvent('tm_block', 'seo_vacancies', landingSlug, true)
  })
}
